import { render } from "./SearchDocument.vue?vue&type=template&id=32e59c3c"
import script from "./SearchDocument.vue?vue&type=script&lang=js"
export * from "./SearchDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__